import Ajax from "Utils/ajax";
export const getAllCompanyList = (data) => Ajax.post('hr/getAllCompanyList',data);
export const getMonthlyAttendanceReportHR = (data) => Ajax.post('hr/getMonthlyAttendanceReportHR',data);
export const freezeAttendance = (data) => Ajax.post('hr/freezeAttendance',data);